import { draftsEffects } from './index';

draftsEffects.deleteDraft.doneData.watch(() => {
    draftsEffects.getDrafts(null);
});
